import * as Yup from "yup";

// Configure Yup to treat empty strings as undefined for validation
Yup.setLocale({
  string: {
    min: ({ min }) => ({ key: "validation.string.min", values: { min } }),
  },
});

const ticketScheme = Yup.object().shape({
  estateId: Yup.number().required("Estate ID is required"),
  subject: Yup.string()
    .transform((value) => (value === "" ? undefined : value))
    .required("Subject is required"),
  body: Yup.string(),
  place: Yup.string(),
  serviceType: Yup.number().required("Service type is required"),
  capture: Yup.array(),
  anonymous: Yup.boolean(),
  private: Yup.boolean(),
});

export default ticketScheme;
